const roRO= {
    login: {
      title: 'Autentificare',
      sign_in_btn: 'Autentificare'
    },
    bar: {
        logout: 'Deconectare',
        languages: 'Limbi',
        settings: 'Deschideți setările'
    },
    language: {
      name: 'Română (RO)',
    },
    attributePage: {
        title: 'Modificări ale atributelor',
        viewChanges: 'Vizualizați modificările',
        dateTime: 'Data',
        notificationType: 'Tipul notificării',
        notificationValue: 'Valoarea notificării',
        oldValue: 'Valoarea veche',
        newValue: 'Valoarea nouă',
        accept: 'Acceptare',
        reject: 'Respingere',
    },
    Home: 'Pagina de pornire',
    load: 'Se efectuează încărcarea inițială...',
    Requested: "Solicitat",
    Viewed: "Vizualizat",
    Executing: "Se execută",
    Completed: "Finalizat",
    Expired: "Expirat",
    Cancelled: "Anulat",
    Error: "Eroare",
    Rejected: "Respins",
    error: 'Ceva nu a mers bine; încercați din nou mai târziu.',
    displayname: 'Numele afișat',
    givenname: 'Prenumele',
    surname: 'Numele de familie',
    email: 'E-mail',
    mail: 'E-mail',
    name: 'Prenumele',
    firstname: 'Prenumele',
    lastname: 'Numele de familie',
    footer_copyright: 'Toate drepturile rezervate.'
  };
  
  export default roRO;
  